<template>
	<el-main class="bg-info-light">
		<div class="padding-20">
			<el-form  v-if="info" label-width="100px">
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form :model="form" ref="form" inline>
							<el-form-item label="审核状态" prop="state">
								<type-select v-model="form.state" :options="[{id:0,name:'待审核'},{id:1,name:'通过'},{id:2,name:'拒绝'}]"></type-select>
							</el-form-item>
							<el-form-item label="拒绝原因" prop="reason" v-if="form.state === 2" :rules="[{required:true,message:'拒绝原因必填'}]">
								<el-input
									placeholder="请输入内容"
									maxlength="100"
									show-word-limit
									style="width: 300px;"
									v-model="form.reason">
								</el-input>
							</el-form-item>
							<el-button type="primary" @click="submit">保存</el-button>
							<el-button @click="$router.back()">返回</el-button>
						</el-form>
					</el-col>
					<template v-if="usertype === 'gys'">
						<el-col :span="8">
							<el-card>
								<div slot="header" class="clearfix">
									<span>基本信息</span>
								</div>
								<el-form-item label="审核状态:">
									<span class="warning" v-if="info.state === 0">待审核</span>
									<span class="success" v-if="info.state === 1">已通过</span>
									<span class="danger" v-if="info.state === 2">已拒绝</span>
								</el-form-item>
								<el-form-item label="身份:">
									<span v-if="info.user_type === 'gys'">供应商</span>
									<span v-if="info.user_type === 'hz'">货主</span>
								</el-form-item>
								<el-form-item label="供应商类型:" v-if="info.user_type === 'gys'">
									<span v-if="info.gys_type === 'wuliu'">物流供应商</span>
									<span v-if="info.gys_type === 'shebei'">设备供应商</span>
								</el-form-item>
								<el-form-item label="优势产品:" v-if="info.user_type === 'gys'">
									{{info.superiority_str}}
								</el-form-item>
								<el-form-item label="办公区域:">{{info.bangong_province_name && info.bangong_city_name ? info.bangong_province_name +' '+info.bangong_city_name : ''}}</el-form-item>
								<el-form-item label="公司名称:">{{info.company}}</el-form-item>
								<el-form-item label="LOGO:">
									<el-image
										style="height: 60px"
										:src="info.logo.indexOf('http')>= 0 ? info.logo : $config.assetsUrl + info.logo"
										:preview-src-list="info.logo.indexOf('http')>= 0 ? [info.logo] : [$config.assetsUrl + info.logo]" v-if="info.logo">
									</el-image>
								</el-form-item>
								<el-form-item label="注册资金:">{{info.zczj}}</el-form-item>
								<el-form-item label="联系人:">{{info.contact}}</el-form-item>
								<el-form-item label="联系方式:">{{info.phone}}</el-form-item>
								<el-form-item label="职位:">{{info.job}}</el-form-item>
								<el-form-item label="行业类型:">{{info.industry_str}}</el-form-item>
								<el-form-item label="服务类型:">{{info.fuwu_str}}</el-form-item>
								<el-form-item label="服务区域:">{{info.province_str}}</el-form-item>
								<el-form-item label="冷库容量:">{{info.lkmj}}m³</el-form-item>
								<el-form-item label="仓库容量:">{{info.cwkmj}}m³</el-form-item>
								<el-form-item label="自有运力:">{{info.zyyl}}辆</el-form-item>
								<el-form-item label="合作客户:">{{info.hzkh}}</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8">
							<el-card>
								<div slot="header" class="clearfix">
									<span>企业介绍</span>
								</div>
								<el-form-item label="企业官网:"><a :href="info.homesite" target="_blank">{{info.homesite}}</a></el-form-item>
								<el-form-item label="企业介绍:">
									<a v-if="info.ppt" :href="info.ppt.indexOf('http') >= 0 ? info.ppt : $config.assetsUrl + info.ppt" target="_blank">企业介绍</a>
								</el-form-item>
							</el-card>
							<el-card class="margin-top">
								<div slot="header" class="clearfix">
									<span>重要资质</span>
								</div>
								<template v-if="info.zizhi_files && info.zizhi_files.length > 0">
									<el-form-item :label="item.name+':'" v-for="(item,index) in info.zizhi_files">
<!--										<el-image style="height: 60px"-->
<!--											:src="item.file.indexOf('http')>= 0 ? item.file : $config.assetsUrl + item.file"-->
<!--											:preview-src-list="item.file.indexOf('http')>= 0 ? [item.file] : [$config.assetsUrl + item.file]" v-if="item.file">-->
<!--										</el-image>-->
										<template v-if="typeof item.file === 'string'">
											<div v-if="item.file"><a :href="item.file.indexOf('http')>= 0 ? item.file : $config.assetsUrl + item.file" target="_blank" style="border-radius: 9999px;background-color: #d1e7ff;padding:3px 10px;">{{item.file.replace(/\/.+\//,'')}}</a></div>
										</template>
										<template v-else>
											<div v-for="(st,si) in item.file" v-if="st"><a :href="st && st.indexOf('http')>= 0 ? st : $config.assetsUrl + st" target="_blank" style="border-radius: 9999px;background-color: #d1e7ff;padding:3px 10px;">{{st && st.replace(/\/.+\//,'')}}</a></div>
										</template>
									</el-form-item>
								</template>
							</el-card>
						</el-col>
						<el-col :span="8">
							<el-card>
								<div slot="header" class="clearfix">
									<span>重要评估认证</span>
								</div>
								<template v-if="info.pinggu_files && info.pinggu_files.length > 0">
									<el-form-item :label="item.name+':'" v-for="(item,index) in info.pinggu_files">
<!--										<el-image-->
<!--											style="height: 60px"-->
<!--											:src="item.file.indexOf('http')>= 0 ? item.file : $config.assetsUrl + item.file"-->
<!--											:preview-src-list="item.file.indexOf('http')>= 0 ? [item.file] : [$config.assetsUrl + item.file]" v-if="item.file">-->
<!--										</el-image>-->
										<template v-if="typeof item.file === 'string'">
											<div v-if="item.file"><a :href="item.file && item.file.indexOf('http')>= 0 ? item.file : $config.assetsUrl + item.file" target="_blank" style="border-radius: 9999px;background-color: #d1e7ff;padding:3px 10px;">{{item.file.replace(/\/.+\//,'')}}</a></div>
										</template>
										<template v-else>
											<div v-for="(st,si) in item.file" v-if="st"><a :href="st && st.indexOf('http')>= 0 ? st : $config.assetsUrl + st" target="_blank" style="border-radius: 9999px;background-color: #d1e7ff;padding:3px 10px;">{{st && st.replace(/\/.+\//,'')}}</a></div>
										</template>
									</el-form-item>
								</template>
							</el-card>
							<el-card class="margin-top">
								<div slot="header" class="clearfix">
									<span>企业荣誉</span>
								</div>
								<template v-if="info.rongyu_files && info.rongyu_files.length > 0">
									<el-form-item :label="item.name+':'" v-for="(item,index) in info.rongyu_files">
<!--										<el-image-->
<!--											style="height: 60px"-->
<!--											:src="item.file.indexOf('http')>= 0 ? item.file : $config.assetsUrl + item.file"-->
<!--											:preview-src-list="item.file.indexOf('http')>= 0 ? [item.file] : [$config.assetsUrl + item.file]" v-if="item.file">-->
<!--										</el-image>-->
										<template v-if="typeof item.file === 'string'">
											<div v-if="item.file"><a :href="item.file.indexOf('http')>= 0 ? item.file : $config.assetsUrl + item.file" target="_blank" style="border-radius: 9999px;background-color: #d1e7ff;padding:3px 10px;">{{item.file.replace(/\/.+\//,'')}}</a></div>
										</template>
										<template v-else>
											<div v-for="(st,si) in item.file" v-if="st"><a :href="st && st.indexOf('http')>= 0 ? st : $config.assetsUrl + st" target="_blank" style="border-radius: 9999px;background-color: #d1e7ff;padding:3px 10px;">{{st && st.replace(/\/.+\//,'')}}</a></div>
										</template>
									</el-form-item>
								</template>
							</el-card>
						</el-col>
					</template>
					<template v-if="usertype === 'hz'">
						<el-col :span="24">
							<el-card>
								<div slot="header" class="clearfix">
									<span>基本信息</span>
								</div>
								<el-form label-width="100px">
									<el-row>
										<el-col :span="8">
											<el-form-item label="审核状态:">
												<span class="warning" v-if="info.state === 0">待审核</span>
												<span class="success" v-if="info.state === 1">已通过</span>
												<span class="danger" v-if="info.state === 2">已拒绝</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="身份:">
												<span v-if="info.user_type === 'gys'">供应商</span>
												<span v-if="info.user_type === 'hz'">货主</span>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="办公区域:">{{info.bangong_province_name && info.bangong_city_name ? info.bangong_province_name +' '+info.bangong_city_name : ''}}</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="公司名称:">{{info.company}}</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="LOGO:">
												<el-image
													style="height: 60px"
													:src="info.logo.indexOf('http')>= 0 ? info.logo : $config.assetsUrl + info.logo"
													:preview-src-list="info.logo.indexOf('http')>= 0 ? [info.logo] : [$config.assetsUrl + info.logo]" v-if="info.logo">
												</el-image>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="联系人:">{{info.contact}}</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="联系方式:">{{info.phone}}</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="职位:">{{info.job}}</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item label="行业类型:">{{info.industry_str}}</el-form-item>
										</el-col>
<!--										<el-col :span="8">-->
<!--											<el-form-item label="服务类型:">{{info.fuwu_str}}</el-form-item>-->
<!--										</el-col>-->
										<el-col :span="8">
											<el-form-item label="服务区域:">{{info.province_str}}</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</el-card>
						</el-col>
					</template>
				</el-row>
			</el-form>
		</div>
	</el-main>
</template>

<script>
export default {
	name: "check",
	data() {
		return {
			info:null,
			id:'',
			form:{
				state:0,
				reason:''
			},
			usertype:''
		}
	},
	created() {
		this.id = this.$route.query.id ? this.$route.query.id : '';
		// this.usertype = this.$route.params.usertype ? this.$route.params.usertype : '';
	},
	mounted() {
		this.getDetail();
	},
	methods: {
		getDetail(){
			let _this = this;

			this.$http.httpPost({
				url:'/UserCompany/detail',
				datas:{id:this.id},
				success(res){
					console.log(res);
					_this.info = res;
					_this.form.state = res.state;
					_this.usertype = res.user_type;
					_this.form.reason = res.reason;
				}
			})
		},
		submit(){
			let _this = this;
			this.$refs['form'].validate((valid) => {
				console.log(valid)
				if (valid) {
					_this.$http.httpPost({
						url:'/UserCompany/changeCheck',
						datas:{id:_this.id,..._this.form},
						success(res){
							_this.$message.success('操作成功');
							_this.$router.back();
						}
					})
				}
			});
		}
	}
}
</script>
